"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBestAvailablePlatformToken = void 0;
const useIsMaxDaresReached_1 = require("root/src/client/logic/dropEvent/hooks/useIsMaxDaresReached");
const calculateMaxDares_1 = require("root/src/shared/util/calculateMaxDares");
const useUser_1 = require("root/src/client/logic/userData/hooks/useUser");
const useDropEvent_1 = require("root/src/client/logic/dropEvent/hooks/useDropEvent");
// Find the best platform that hasn't reached max dares by recursion
function useBestAvailablePlatformToken(dropEvent) {
    var _a;
    const { connectedPlatforms, averageCcv, tokens, } = (0, useUser_1.useUserCreatorData)();
    const userCampaignData = (0, useDropEvent_1.useUserCampaignData)();
    const maxFollowerCount = (0, useUser_1.useMaxCreatorFollowerCount)();
    const campaign = (_a = (0, useDropEvent_1.useDropEvent)()) !== null && _a !== void 0 ? _a : dropEvent;
    if (!campaign) {
        return null;
    }
    return getBestPlatformToken({ campaign, averageCcv, maxFollowerCount, connectedPlatforms, tokens, userCampaignData });
}
exports.useBestAvailablePlatformToken = useBestAvailablePlatformToken;
function getBestPlatformToken({ connectedPlatforms, campaign, averageCcv, maxFollowerCount, tokens, userCampaignData }) {
    const bestPlatform = (0, calculateMaxDares_1.calculateMaxDaresForBestPlatform)({
        followerCount: maxFollowerCount, averageCcv, campaign, connectedPlatforms,
    });
    if (!bestPlatform) {
        return null;
    }
    const isMaxDaresReached = (0, useIsMaxDaresReached_1.isMaxDaresReachedByPlatform)({
        maxDares: bestPlatform.maxDares, platform: bestPlatform.platform, dropEvent: campaign, userCampaignData,
    });
    if (!isMaxDaresReached) {
        return getTokenByPlatform(tokens, bestPlatform);
    }
    const slicedPlatforms = connectedPlatforms.filter(platform => platform !== bestPlatform.platform);
    if (!slicedPlatforms.length) {
        return getTokenByPlatform(tokens, bestPlatform);
    }
    return getBestPlatformToken({
        connectedPlatforms: slicedPlatforms,
        campaign,
        tokens,
        maxFollowerCount,
        averageCcv,
    });
}
function getTokenByPlatform(tokens, bestPlatform) {
    var _a;
    return (_a = tokens === null || tokens === void 0 ? void 0 : tokens.find(token => token.platform === (bestPlatform === null || bestPlatform === void 0 ? void 0 : bestPlatform.platform))) !== null && _a !== void 0 ? _a : null;
}
